import {
  Component,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { CrudbarNavComponent } from "../crudbar-nav/crudbar-nav.component";
import { MaterialModule } from '../../material.module';


/**
 * 資料集CRUD操作工具列組件
 *
 * 繼承自CrudbarNavComponent，專用於資料集（DataSet）操作。
 * 此組件通常用於主從表單中的子表資料操作，如訂單明細、
 * 發票項目等。與一般的CRUD工具列不同，此組件專注於
 * 子表資料的管理。
 */
@Component({
  selector: 'app-crudbar-ds',
  templateUrl: './crudbar-ds.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialModule,
    MatIcon],
})
export class CrudbarDataSetComponent extends CrudbarNavComponent implements OnInit {
  /**
   * 組件類型標識符，用於區分不同類型的工具列
   * 值為 'crudbards'，表示此為資料集操作工具列
   */
  override comType: string = 'crudbards';
  constructor() {
    super();
  }

  /**
   * 獲取刪除按鈕是否禁用的狀態
   * 用於測試目的
   */
  public get test(): boolean {
    return this.deleteDisabled;
  }

  /**
   * 設定刪除按鈕是否禁用的狀態
   * 用於測試目的
   */
  public set test(t: boolean) {
    this.deleteDisabled = t;
  }
}
